module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page terms-page",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "content-page"
  }, [_c('v-navigation-drawer', {
    attrs: {
      "permanent": "",
      "fixed": "",
      "height": "100vh"
    }
  }, [_c('div', {
    staticClass: "page-title"
  }), _vm._v(" "), _c('v-list', _vm._l((_vm.tabs), function(t) {
    return _c('v-list-tile', {
      key: t.id,
      class: {
        active: t.id == _vm.active_tab
      },
      attrs: {
        "href": ("#" + (t.id))
      },
      nativeOn: {
        "click": function($event) {
          _vm.onTab(t.id)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(t.title))])], 1)
  }))], 1), _vm._v(" "), (_vm.active_tab == 'team') ? _c('team-tab') : (_vm.active_tab == 'product') ? _c('product-tab') : (_vm.active_tab == 'timeline') ? _c('timeline-tab') : (_vm.active_tab == 'success') ? _c('success-tab') : (_vm.active_tab == 'opportunity') ? _c('opportunity-tab') : (_vm.active_tab == 'features') ? _c('features-tab') : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c3ff6b2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/overview/index.vue
// module id = 1687
// module chunks = 180